import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  ebayCaregoryLoadAspects,
  ebayCategoryLoad,
  ebayCategorySave,
  ebayCategorySaveAspects,
  ebayCategorySuggestions,
  ebayGetUserUrl,
  ebayInventoryItemDelete,
  ebayInventoryItemLoad,
  ebayInventoryItemPut,
  ebayMarketplaceLoad,
  ebayMarketplaceLoadFulfillmentPolicies,
  ebayMarketplaceLoadPaymentPolicies,
  ebayMarketplaceLoadReturnPolicies,
  ebayMarketplaceSetCurrency,
  ebayMarketplaceSetIsActive,
  ebayMarketplaceSetLanguage,
  ebayMarketplacesLoad,
  ebayMarketplacReloadCategories,
  ebayMarketplacReloadDefaultCategoryId,
  ebayMarketplacReloadFulfillmentPolicies,
  ebayMarketplacReloadPaymentPolicies,
  ebayMarketplacReloadReturnPolicies,
  ebayOfferDelete,
  ebayOfferPost,
  ebayOfferPublish,
  ebayOfferPut,
  ebayOffersLoad,
  ebayProductLoad,
  ebayProductSave,
  ebayUserCode,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(ebayCaregoryLoadAspects.type, send, socket);
  yield takeEvery(ebayCategoryLoad.type, send, socket);
  yield takeEvery(ebayCategorySaveAspects.type, send, socket);
  yield takeEvery(ebayCategorySave.type, send, socket);
  yield takeEvery(ebayCategorySuggestions.type, send, socket);
  yield takeEvery(ebayInventoryItemDelete.type, send, socket);
  yield takeEvery(ebayInventoryItemLoad.type, send, socket);
  yield takeEvery(ebayInventoryItemPut.type, send, socket);
  yield takeEvery(ebayMarketplaceLoadFulfillmentPolicies.type, send, socket);
  yield takeEvery(ebayMarketplaceLoadPaymentPolicies.type, send, socket);
  yield takeEvery(ebayMarketplaceLoadReturnPolicies.type, send, socket);
  yield takeEvery(ebayMarketplaceLoad.type, send, socket);
  yield takeEvery(ebayMarketplacReloadCategories.type, send, socket);
  yield takeEvery(ebayMarketplacReloadDefaultCategoryId.type, send, socket);
  yield takeEvery(ebayMarketplacReloadFulfillmentPolicies.type, send, socket);
  yield takeEvery(ebayMarketplacReloadPaymentPolicies.type, send, socket);
  yield takeEvery(ebayMarketplacReloadReturnPolicies.type, send, socket);
  yield takeEvery(ebayMarketplaceSetCurrency.type, send, socket);
  yield takeEvery(ebayMarketplaceSetIsActive.type, send, socket);
  yield takeEvery(ebayMarketplaceSetLanguage.type, send, socket);
  yield takeEvery(ebayMarketplacesLoad.type, send, socket);
  yield takeEvery(ebayOfferDelete.type, send, socket);
  yield takeEvery(ebayOfferPost.type, send, socket);
  yield takeEvery(ebayOfferPublish.type, send, socket);
  yield takeEvery(ebayOfferPut.type, send, socket);
  yield takeEvery(ebayOffersLoad.type, send, socket);
  yield takeEvery(ebayProductLoad.type, send, socket);
  yield takeEvery(ebayProductSave.type, send, socket);
  yield takeEvery(ebayUserCode.type, send, socket);
  yield takeEvery(ebayGetUserUrl.type, send, socket);
}
